import React, { Component } from 'react';

import './Icon.css';

class Icon extends Component {

    render() {
        var iconStyle = {
            width: this.props.size +'px',
            height: this.props.size +'px',
            lineHeight: this.props.size +'px',
            fontSize: (this.props.size * 0.5) +'px'
        };

        return (
            <div className="icon-wrapper">
                <span className={"glyphicon glyphicon-"+this.props.icon} style={iconStyle} />
            </div>
        );
    }

}

export default Icon;



// WEBPACK FOOTER //
// ./src/components/Icon.js